export default __webpack_public_path__ + "static/media/somethingWentWrong.e29a364f.svg";